// localStorage keys (tsetsu.* — нэг backend, нэг auth).
const K = {
  token: 'tsetsu.token',
  appUserId: 'tsetsu.appUserId',
  phone: 'tsetsu.phone',
  displayName: 'tsetsu.displayName',
  tenantId: 'tsetsu.tenantId',
  tenantName: 'tsetsu.tenantName',
  companyId: 'tsetsu.companyId',
  companyName: 'tsetsu.companyName',
} as const;

export interface LoginResponse {
  Token: string;
  AppUserId: string;
  DisplayName?: string;
  Phone?: string;
  IsNewUser?: boolean;
  Tenants?: { TenantId: string; TenantName: string }[];
  DefaultTenantId?: string | null;
  DefaultTenantName?: string | null;
  DefaultCompanyId?: string | null;
  DefaultCompanyName?: string | null;
}

export const auth = {
  get token() {
    return localStorage.getItem(K.token);
  },
  get appUserId() {
    return localStorage.getItem(K.appUserId);
  },
  get phone() {
    return localStorage.getItem(K.phone);
  },
  get displayName() {
    return localStorage.getItem(K.displayName);
  },
  getScopeCache() {
    return {
      tenantId: localStorage.getItem(K.tenantId),
      companyId: localStorage.getItem(K.companyId),
      tenantName: localStorage.getItem(K.tenantName),
      companyName: localStorage.getItem(K.companyName),
    };
  },
  setScopeCache(s: { tenantId: string; companyId: string; tenantName?: string; companyName?: string }) {
    localStorage.setItem(K.tenantId, s.tenantId);
    localStorage.setItem(K.companyId, s.companyId);
    if (s.tenantName) localStorage.setItem(K.tenantName, s.tenantName);
    if (s.companyName) localStorage.setItem(K.companyName, s.companyName);
  },
  saveLogin(res: LoginResponse) {
    localStorage.setItem(K.token, res.Token);
    localStorage.setItem(K.appUserId, res.AppUserId);
    if (res.DisplayName) localStorage.setItem(K.displayName, res.DisplayName);
    if (res.Phone) localStorage.setItem(K.phone, res.Phone);
    if (res.DefaultTenantId) localStorage.setItem(K.tenantId, res.DefaultTenantId);
    if (res.DefaultTenantName) localStorage.setItem(K.tenantName, res.DefaultTenantName);
    if (res.DefaultCompanyId) localStorage.setItem(K.companyId, res.DefaultCompanyId);
    if (res.DefaultCompanyName) localStorage.setItem(K.companyName, res.DefaultCompanyName);
  },
  clear() {
    Object.values(K).forEach((k) => localStorage.removeItem(k));
  },
  get isAuthed() {
    return !!localStorage.getItem(K.token);
  },
};
